import { Col, pagination, Row, Table } from "antd";
import { onShowSizeChange, itemRender } from "../Pagination";
import { Link } from "react-router-dom";
import { useState ,useEffect} from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { SettingOutlined } from '@ant-design/icons'; // Ensure this is imported
import {
  imagesend,
  pdficon,
  pdficon2,
  pdficon3,
  blogimg2,
  blogimg4,
  blogimg6,
  blogimg12,
  blogimg10,
  blogimg8,
  pdficon4,
  plusicon,
  refreshicon,
  searchnormal,
} from "../imagepath";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import AddModal from "./AddModal";
import { getsymptom } from "../../services/doctor/symptom/symptom";
import Loader from "../Loader";
import { useAuth } from "../../services/authentication_API/authService";
import { getFees } from "../../services/doctor/fees/fees";
import FeeModal from "./AddBillItemModal";
import { Settings, SettingsIcon } from "lucide-react";
import BillSettingModal from "../Billong/BillSettingModal";

const Fees = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [datasource, setDatasource] = useState([]); // Start with empty array
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const {userData}=useAuth();
  const [showBillSettingModal, setBillSettingModalVisible] = useState(false);


  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const [show, setShow] = useState(false)
  const [isEdit, setisEdit] = useState(false)
  const [selectedData, setSelectedData] = useState(null)

  useEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (sidebar) {
      sidebar.classList.add("sidebar-doctor");
      sidebar.id = "menu-item1"; // Change ID if needed
    }
    
      document.body.classList.remove("expand-menu");
      document.body.classList.add("mini-sidebar");

  }, []);

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const fetchFees = async () => {
    try {
      setLoading(true);
      const result = await getFees(searchKeyword,userData?.id);
      if (result.success) {
        // Format DosageTime if needed
        
        setDatasource(result?.data);
        setLoading(false);
      } else {
        // Optionally handle error
        setDatasource([]);
      }
    } catch (err) {
      // Optionally handle error
      setDatasource([]);
    }
  };
  useEffect(() => {
    

    fetchFees();
  }, [refresh,searchKeyword]);
  
  
  const columns = [
    {
      title: "Fee Name",
      dataIndex: "fee_name",
      // sorter: (a, b) => a.SymptomName.length - b.SymptomName.length,
    },
    {
      title: "Type",
      dataIndex: "fee_type",
    //   sorter: (a, b) => a.Description.length - b.Description.length,
    },
    {
      title: "Amount",
      dataIndex: "fee_amount",
    //   sorter: (a, b) => a.Description.length - b.Description.length,
    },
    
    {
      title: "",
      dataIndex: "FIELD8",
      render: (text, record) => (
        <>
          <div className="text-end">
            <div className="dropdown dropdown-action">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ellipsis-v" />
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
              <Link className="dropdown-item" to="#" onClick={()=>{setShow(true), setisEdit(true),setSelectedData(record)}}>
                  <i className="far fa-edit me-2" />
                  Edit
                </Link>
 
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      <div>
        <Sidebar id="menu-item1" id1="menu-items1" activeClassName="symptoms" />
        <div className="page-wrapper-doctor">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Doctor&apos;s Setting </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Billing</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <Row className="mb-12">
                    <Col sm={12}>
                      <div className="card-body">
                        {/* Table Header */}
                        <div className="page-table-header mb-2">
                          <div className="row align-items-center">
                            <div className="col">
                              <div className="doctor-table-blk">
                                <h3>Billing Item List</h3>
                                <div className="doctor-search-blk">
                                  <div className="top-nav-search table-search-blk">
                                    <form>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search here"
                                        onChange={(e) => {
                                          setSearchKeyword(e.target.value);
                                        }}
                                      />
                                      <Link
                                        className="btn"
                                        onClick={(e) => fetchFees()}
                                      >
                                        <img src={searchnormal} alt="#" />
                                      </Link>
                                    </form>
                                  </div>
                                  <div className="add-group">
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        (setSelectedData(null),
                                          setShow(true),
                                          setisEdit(false));
                                      }}
                                      className="btn btn-primary add-pluss ms-2"
                                    >
                                      <img src={plusicon} alt="#" />
                                    </Link>
                                    <Link
                                      to="#"
                                      className="btn btn-primary doctor-refresh ms-2"
                                      onClick={(e) => setRefresh(!refresh)}
                                    >
                                      <img src={refreshicon} alt="#" />
                                    </Link>
                                    <Link
                                      to="#"
                                      // Ensure 'd-flex' or 'd-inline-flex' is in the className if not using the style object
                                      className=" align-items-center justify-content-center"
                                      onClick={() =>
                                        setBillSettingModalVisible(true)
                                      }
                                      style={{
                                        display: "inline-flex", // CRITICAL: Enables flexbox to make vertical centering work
                                        alignItems: "center", // Vertically centers the icon and text
                                        justifyContent: "center", // Horizontally centers the content
                                        height: "40px",
                                        padding: "0 15px",
                                        borderRadius: "8px",
                                        gap: "8px",
                                        border: "none",
                                        textDecoration: "none",
                                        color: "#2e37a4", // Assuming white text for your primary blue button
                                      }}
                                    >
                                      {/* display: flex on the icon prevents it from having extra bottom whitespace */}
                                      <SettingOutlined
                                        style={{
                                          fontSize: "18px",
                                          display: "flex",
                                        }}
                                      />

                                      <span
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: "500",
                                          lineHeight: "1", // Use line-height 1 for exact vertical precision
                                          display: "inline-block",
                                        }}
                                      >
                                        Settings
                                      </span>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Table Header */}

                        <div className="table-responsive">
                          {loading ? (
                            <Loader />
                          ) : (
                            <Table
                              pagination={{
                                total: datasource.length,
                                showTotal: (total, range) =>
                                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                itemRender: itemRender,
                                style: { paddingRight: "14px" },
                              }}
                              columns={columns}
                              dataSource={datasource}
                              rowSelection={rowSelection}
                              rowKey={(record) => record.id}
                            />
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Delete Modal */}
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this?</h3>
                <div className="m-t-20">
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button type="submit" className="btn btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FeeModal
        show={show}
        onHide={() => setShow(false)}
        refresh={() => setRefresh(!refresh)}
        type="Symptoms"
        isedit={isEdit}
        record={selectedData}
      />
      <BillSettingModal
        visible={showBillSettingModal}
        onClose={() => setBillSettingModalVisible(false)}
        doctorId={userData?.id}
      />
    </>
  );
};

export default Fees;